import { trackCallClick, trackWhatsappClick, trackLocationShare } from '../lib/engine';

/**
 * Wrap a tel: link onClick to track call clicks.
 */
export function onCallClick(page) {
  return () => {
    trackCallClick(page || window.location.pathname);
    if (typeof window.gtag_report_conversion === 'function') {
      window.gtag_report_conversion();
    }
  };
}

/**
 * Wrap a WhatsApp link onClick to track whatsapp clicks.
 */
export function onWhatsappClick(page) {
  return () => {
    trackWhatsappClick(page || window.location.pathname);
    if (typeof window.gtag_report_whatsapp === 'function') {
      window.gtag_report_whatsapp();
    }
  };
}

/**
 * Wrap a location share onClick.
 */
export function onLocationClick(page) {
  return () => trackLocationShare(page || window.location.pathname);
}
